import {FormTextField} from 'src/v2/components/anyCrypto/FormTextField';
import {message, useIntl} from '@sail/intl';

const messages = {
  emailLabel: message({
    id: 'crypto.payins.v2.refund.email_label',
    description: 'Label for email address input on the refund screen',
    defaultMessage: 'Email address',
  }),

  emailDescription: message({
    id: 'crypto.payins.v2.refund.email_description',

    description:
      'Description explaining why the email address is collected on the refund screen',

    defaultMessage: "We'll send refund updates to this address.",
  }),

  emailPlaceholder: message({
    id: 'crypto.payins.v2.refund.email_placeholder',
    description: 'Placeholder for email address input on the refund screen',
    defaultMessage: 'name@example.com',
  }),
};

type EmailAddressSectionProps = {
  email: string;
  onEmailChange: (value: string) => void;
  error?: string;
};

export const EmailAddressSection = ({
  email,
  onEmailChange,
  error,
}: EmailAddressSectionProps) => {
  const intl = useIntl();

  return (
    <FormTextField
      label={intl.formatMessage(messages.emailLabel)}
      description={intl.formatMessage(messages.emailDescription)}
      placeholder={intl.formatMessage(messages.emailPlaceholder)}
      value={email}
      onChange={onEmailChange}
      type="email"
      error={error}
    />
  );
};
